// types
import { TraceabilityTransactions } from '../@types';

export const traceabilityDefault: TraceabilityTransactions = {
	hasId: false,
	documentation: {
		documented: null,
		undocumented: null,
		total: null,
		value: null,
	},
	financial: {
		amounts: [],
		documented: null,
		undocumented: null,
		total: null,
		value: null,
	},
	transactions: [],
};
